import { ICreateGrupoAcessoUseCase } from "../../../presentation/useCases/create/create_grupo_acesso_use_case";
import { IAdministracaoRepository } from "../../repositories/administracao_repository";

/**
 * CreateGrupoAcessoUseCase
 */

export class CreateGrupoAcessoUseCase implements ICreateGrupoAcessoUseCase {
  constructor(private readonly repository: IAdministracaoRepository) { }

  async execute(
    nomeGrupo: string | null,
    descricao: string | null,
    idFuncionario: number | null,

    idsAtribuicaoGrupo?: number[]
  ): Promise<number> {
    const grupoAcessoId = await this.repository.createGrupoAcesso(
      nomeGrupo,
      descricao,
      idFuncionario,
      idsAtribuicaoGrupo

    );

    return grupoAcessoId;
  }

}
